import React, { useState } from "react";
import { useCart, useCustomer } from "hooks/useStore";
import QuantityPicker from "components/product/quantity-picker";
import WishlistModalTriggerButton from "components/wishlist/modal-trigger-button";
import WishlistModal from "components/wishlist/modal";
import WarrantyModal from "components/warranty-modal";
import { warrantyCloseData } from "helpers/warranty";
import useToggle from "hooks/useToggle";
import { trackAddToCart } from "analytics";
import clsx from "clsx/lite";
import Money from "components/money";
import Loader from "components/loader";
import usePostATCAction from "hooks/usePostATCAction";
import { isExperienceActive } from "helpers/convert";

const AddToCart = ({ product, quantityConfig, warranty, hideWishlistIcon = false, buttonClass, children, hidePrice = false }) => {
	const [quantity, setQuantity] = useState(quantityConfig?.defaultValue || 1);
	const [isLoading, toggleLoading] = useToggle();
	const { addCartItem } = useCart(["addCartItem"]);
	const [isWishlistModalOpen, toggleWishlistModal] = useToggle();
	const [iswarrantyModalOpen, toggleWarrantyModal] = useToggle();
	const customer = useCustomer();
	const postAddToCartAction = usePostATCAction();

	const { price, markets } = product.variant;
	const activeWarranty = warranty?.status === "active" && warranty?.variant?.isAvailable;

	const handleAddToCart = async () => {
		if (!product.variant.isAvailable || isLoading) return;
		toggleLoading();
		const attributes = [];
		if (activeWarranty) {
			attributes.push({ key: "_warranty", value: warranty.variant.gid });
		}

		await addCartItem(product.variant.gid, quantity, attributes);
		trackAddToCart({ ...product, quantity }, customer);
		toggleLoading();

		if (activeWarranty && warrantyCloseData().count < 3 && !isExperienceActive(["v.1004354111"])) {
			return toggleWarrantyModal();
		}
		postAddToCartAction();
	};

	return (
		<>
			{isWishlistModalOpen && <WishlistModal product={product} isOpen={isWishlistModalOpen} toggle={toggleWishlistModal} />}
			{activeWarranty &&
				<WarrantyModal product={warranty} isOpen={iswarrantyModalOpen} toggleModal={toggleWarrantyModal} />}
			<div className="flex flex-col gap-4 md:gap-9">
				<div className={clsx(children && "flex gap-4")}>
					{children}
					<div className={clsx("flex flex-col", children && "w-1/3 md:w-1/2")}>
						<p className="mb-2 text-secondary">Quantity: {quantity}</p>
						<QuantityPicker config={quantityConfig} setQuantity={setQuantity}
							quantity={quantity} isCustomDefaultValue={!!children} />
					</div>
				</div>
				<div className="flex gap-3.5">
					<button
						disabled={!product.variant.isAvailable || isLoading}
						className={clsx(
							"w-full py-3 btn-primary text-base tracking-widest px-2",
							isLoading && "pointer-events-none", buttonClass)}
						onClick={handleAddToCart}
					>
						{isLoading ? <Loader className="size-5" ring /> :
							<span className={clsx("flex justify-center gap-1", children && "text-base")}>
								Add to cart
								{!hidePrice &&
									<>
										<span className="px-0.5">-</span>
										<Money value={price * quantity} markets={markets} quantity={quantity} />
									</>
								}
							</span>}
					</button>
					{!hideWishlistIcon &&
						<WishlistModalTriggerButton product={product} beigeHeart
							className="p-3.5 bg-gray-200/30 flex w-fit" iconClassName="size-5 fill-black" />}
				</div>
			</div>
		</>
	);
};

export default AddToCart;